var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-insights" },
    [
      _c(
        "carousel",
        {
          attrs: { "per-page": 4, navigationEnabled: true, "mouse-drag": false }
        },
        [
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h3", { staticStyle: { "text-align": "left" } }, [
                    _vm._v("Total Camera Time:")
                  ]),
                  _c(
                    "h2",
                    {
                      staticStyle: { "text-align": "left", "font-size": "16px" }
                    },
                    [_vm._v(_vm._s(_vm.photoTotalTimeMinutes / 60) + " Hr")]
                  )
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h3", { staticStyle: { "text-align": "left" } }, [
                    _vm._v("Avg Camera Time:")
                  ]),
                  _c(
                    "h2",
                    {
                      staticStyle: { "text-align": "left", "font-size": "16px" }
                    },
                    [_vm._v(_vm._s(_vm.photoAvgTimeMinutes) + " Minutes")]
                  )
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h3", { staticStyle: { "text-align": "left" } }, [
                    _vm._v("Minimum Camera Time:")
                  ]),
                  _c(
                    "h2",
                    {
                      staticStyle: { "text-align": "left", "font-size": "16px" }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.photoFastestActivityMinutes) + " Minutes"
                      )
                    ]
                  )
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h3", { staticStyle: { "text-align": "left" } }, [
                    _vm._v("Maximum Camera Time:")
                  ]),
                  _c(
                    "h2",
                    {
                      staticStyle: { "text-align": "left", "font-size": "16px" }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.photoSlowestActivityminutes) + " Minutes"
                      )
                    ]
                  )
                ])
              ])
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }